import React from 'react'
import { RegisterNode } from 'gg-editor'

class CustomNode extends React.Component {
  render() {
    const config = {
      draw(item) {
        const keyShape = this.drawKeyShape(item)

        // 绘制图标 วาดไอคอน
        const group = item.getGraphicGroup()
        const model = item.getModel()

        group.addShape('image', {
          attrs: {
            x: 0,
            y: 0,
            width: 15,
            height: 15,
            img: model.icon,
          },
        })

        // 绘制标签 วาดฉลาก
        this.drawLabel(item)

        return keyShape
      },

      anchor: [
        [0.5, 9], // 上边中点 จุดกึ่งกลางด้านบน
        [0.5, 1], // 底边中点 จุดกึ่งกลางด้านล่่าง
      ],
    }

    return (
      <RegisterNode name="custom-node-rhombus" config={config} extend={'flow-rhombus'} />
    )
  }
}

export default CustomNode
